import { FunctionComponent, ReactNode } from 'react';
import { useFragment, graphql } from 'react-relay';
import { useDispatch } from 'react-redux';
import { Link } from 'dibs-elements/exports/Link';
import { useCheckoutSelector } from '../reducers/root';
import { navigateToPane } from '../actions/checkoutUIActions';
import { Pane } from '../constants/checkoutConstants';

import { CheckoutStepLink_buyer$key } from './__generated__/CheckoutStepLink_buyer.graphql';

type CheckoutStepLinkProps = {
    isComputing: boolean;
    step: Pane;
    children: ReactNode;
    buyer: CheckoutStepLink_buyer$key | null;
};

export const CheckoutStepLink: FunctionComponent<CheckoutStepLinkProps> = props => {
    const { step, isComputing, children } = props;

    const buyer = useFragment(
        graphql`
            fragment CheckoutStepLink_buyer on User {
                hasShippingAddresses
                hasBankAccounts
                hasCreditCards
            }
        `,
        props.buyer
    );
    const { hasShippingAddresses, hasCreditCards, hasBankAccounts } = buyer || {};

    const dispatch = useDispatch();
    const currentPane = useCheckoutSelector(state => state.pane.currentPane);

    function handleClick(): void {
        navigateToPane({
            pane: step,
            hasShippingAddresses: !!hasShippingAddresses,
            hasCreditCards: !!hasCreditCards,
            hasBankAccounts: !!hasBankAccounts,
            isSummaryOpen: false,
            currentPane,
            isComputing,
            dispatch,
        });
    }

    return <Link onClick={handleClick}>{children}</Link>;
};
